module.exports = __webpack_public_path__ + "static/media/sourcesanspro-lightitalic-webfont.3fa6ebb8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-lightitalic-webfont.woff
// module id = 504
// module chunks = 0